import { DepositMethodType } from '@golden/gdk-admin'
import { useDialogStyles } from '../../../utils/admin/StyleHook'
import useT from '../../../i18ns/admin/useT'
import useGDK from '../../../providers/admin/gdk/useGDK'
import React, { useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import DropDown from '../../default/form/DropDown'
import { useGetData } from '../../../utils/default/ComplexFlowHook'

const DepositWayGroupDialogDropdown: React.FC<{
  targetId: number
  targetCashText: string
  method: DepositMethodType
  groupId: number | '--'
  handleOnChange: (event: React.ChangeEvent<{
    name?: string | undefined
    value: unknown
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  }>) => boolean | void
}> = (props) => {
  const { targetId, targetCashText, method, groupId, handleOnChange } = props
  const dialogClasses = useDialogStyles()
  const { t } = useT()
  const gdk = useGDK()
  const [internalGroupId, setInternalGroupId] = useState<number | '--'>(groupId)
  const [groups, setGroups] = useState<Array<{
    target_id: number
    id: number
    name: string
    cash_min: string
    cash_max: string
  }>>([])

  useGetData({
    gdkFunc: () => gdk.finance.getDepositWayGroupList({
      method,
      page: 1
    }),
    gdkFuncDependencies: [gdk, method, targetId],
    onSuccess: (res) => {
      setGroups(res.data.map((item) => ({
        target_id: targetId,
        id: item.id,
        name: item.name,
        cash_min: item.cash_min,
        cash_max: item.cash_max
      })))
    }
  })

  const groupOptions = useMemo(() => {
    return [
      {
        name: t('placeholder.notChooseYet'),
        value: '--'
      }
    ].concat(groups.map((el) => ({
      name: `${el.name}[${el.cash_min} - ${el.cash_max}]`,
      value: (el.id).toString()
    })))
  }, [t, groups])

  return (
    <Grid container direction="column" alignItems="center">
      <span className={dialogClasses.title}>{t('dialog.confirmToggleOn')}</span>
      <span className={dialogClasses.text}>{targetCashText}</span>
      <DropDown
        fullWidth
        label={t('page.depositWayGroup')}
        value={internalGroupId}
        options={groupOptions}
        onChange={(event) => {
          const val = event.target.value as number | '--'
          setInternalGroupId(val)
          handleOnChange(event)
        }}
      />
    </Grid>
  )
}

export default React.memo(DepositWayGroupDialogDropdown)
